import consoleApi from '../slices/console/console.api';
import { useAuth } from './use-auth';

export const useAuraUser = () => {
  const auth = useAuth();
  const { data: user, isLoading } = consoleApi.useGetUserDetailsQuery(undefined, {
    skip: !auth.isAuthenticated,
  });

  return { user, isLoading };
};
